import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('activitylist').select();

    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  export async function getDataWithCategory(category) {
    const { data, error } = await supabase.from('activitylist').select().eq('category', category).order('order', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getIdData(id) {
    const { data, error } = await supabase.from('activitylist').select()
    .eq('id', id);
    console.log("getIdData",id,error);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithStudent(studentId) {
    const { data, error } = await supabase.from('activitylist').select().eq('studentId', studentId)
    .order('sortorder', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const { data, error } = await supabase.from('activitylist').insert(adata).select();

    if (error) {
      console.log("addData",error);
      
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('activitylist').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('activitylist').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
